import type { MountDeckPlayerWidgetHandle, MountDeckPlayerWidgetOptions } from '../integration'
import { mountDeckPlayerWidget } from '../integration'
import { DeckPlayerWidgetCount } from '../widgets/components'

const DISPLAY_NAME = 'deckplayer-count'
const DEFAULT_SELECTOR = '[data-deckplayer-widget="deckplayer-count"]'

export function mountDeckPlayerCountWidget(
  target: string | Element = DEFAULT_SELECTOR,
  opts: Omit<MountDeckPlayerWidgetOptions, 'displayName'> = {},
): Promise<MountDeckPlayerWidgetHandle> {
  return mountDeckPlayerWidget(target, DeckPlayerWidgetCount, {
    ...opts,
    displayName: DISPLAY_NAME,
  })
}
